import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { DownloadIcon, FileTextIcon, CheckCircle2Icon } from 'lucide-react';
import { Container } from '../ui/Container';
import { SectionHeading } from '../ui/SectionHeading';
const guides = [{
  title: 'WA Business Owner Legal Health Check',
  benefit: 'Spot the legal gaps most WA business owners miss.'
}, {
  title: 'Franchise Buyer Due Diligence Checklist',
  benefit: 'Know what to check before you sign a franchise agreement.'
}, {
  title: 'Family Law Separation First Steps Guide',
  benefit: 'A calm, practical roadmap for the first weeks of separation.'
}, {
  title: 'WA Estate Planning Checklist',
  benefit: 'Make sure your will, EPA and EPG actually protect your family.'
}, {
  title: 'Commercial Dispute Response Guide',
  benefit: 'What to do in the first 48 hours of a commercial dispute.'
}, {
  title: 'Property Settlement Checklist',
  benefit: 'Keep your WA property settlement on track and stress-free.'
}, {
  title: 'Commercial Lease Review Checklist',
  benefit: 'The clauses that matter most before you commit to a lease.'
}, {
  title: 'Business Succession Planning Guide',
  benefit: 'Plan the handover of your business with confidence.'
}];
export function Guides() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [email, setEmail] = useState('');
  const [captured, setCaptured] = useState<number | null>(null);
  const submit = (i: number) => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
    setCaptured(i);
  };
  return <section id="guides" className="scroll-mt-24 bg-cream py-16 lg:py-24" data-id="element-115">
      <Container data-id="element-116">
        <SectionHeading align="center" eyebrow="Free legal guides" title="Helpful legal guides before you make a decision." intro="Practical, plain-English guides written by our teams — no charge, no obligation. Download the one that fits your situation." data-id="element-117" />

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-118">
          {guides.map((g, i) => <motion.div key={g.title} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 4 * 0.05
        }} className="flex flex-col rounded-xl border border-navy/10 bg-white p-5" data-id="element-119">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-navy/5" data-id="element-120">
                <FileTextIcon className="h-5 w-5 text-brass-dark" data-id="element-121" />
              </span>
              <h3 className="mt-3 font-serif text-base leading-snug text-navy" data-id="element-122">
                {g.title}
              </h3>
              <p className="mt-1.5 flex-1 text-sm leading-relaxed text-ink/60" data-id="element-123">
                {g.benefit}
              </p>

              <AnimatePresence mode="wait" data-id="element-124">
                {captured === i ? <motion.p key="done" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} className="mt-4 flex items-center gap-2 text-sm font-medium text-sage" data-id="element-125">
                    <CheckCircle2Icon className="h-4 w-4" data-id="element-126" /> On its way to your
                    inbox.
                  </motion.p> : openIndex === i ? <motion.div key="form" initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} className="mt-4 space-y-2 overflow-hidden" data-id="element-127">
                    <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Your email address" className="w-full rounded-md border border-navy/15 bg-cream px-3 py-2 text-sm focus:border-brass focus:outline-none focus:ring-2 focus:ring-brass/20" data-id="element-128" />
                    <button onClick={() => submit(i)} className="flex w-full items-center justify-center gap-1.5 rounded-md bg-brass px-3 py-2 text-sm font-semibold text-white hover:bg-brass-dark" data-id="element-129">
                      <DownloadIcon className="h-4 w-4" data-id="element-130" /> Send me the guide
                    </button>
                  </motion.div> : <button key="cta" onClick={() => setOpenIndex(i)} className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:text-brass-dark" data-id="element-131">
                    <DownloadIcon className="h-4 w-4" data-id="element-132" /> Download guide
                  </button>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}